import errors, { FailureAction } from './errors'
import { AllActionTypes } from '../actions'
import breadcrumb from './breadcrumb'
import cart from './cart'
import categories from './categories'
import location from './location'
import navigation from './navigation'
import pages from './pages'
import products from './products'
import search from './search'
import shop from './shop'
import view from './view'

type Reducer = (state: State, action: AllActionTypes | FailureAction) => State

const combineReducers = (reducers: Reducer[]): Reducer => {
  return (state, action) => {
    return reducers.reduce((state, red) => red(state, action), state)
  }
}

export default combineReducers([
  location,
  errors,
  view,
  shop,
  cart,
  navigation,
  categories,
  breadcrumb,
  products,
  search,
  pages,
])
